// @flow

import * as React from 'react';

import { localize } from '@ta/common.i18n';
import { NavigableListItem } from '@ta/list.navigable-list';

import BasicResult from './BasicResult';
import type { TypeaheadResult } from '../TypeaheadResult';
import TypeaheadTracking, { type UserInteractionType } from '../TypeaheadTracking';

type Props = {|
  /** An optional callback if a result is selected */
  onSelection?: (
    event: SyntheticEvent<HTMLElement> | KeyboardEvent,
    result: TypeaheadResult,
  ) => void,

  /** The typeahead tracker */
  tracker: TypeaheadTracking,

  /** An optional callback for if/when the mouse moves over the result */
  onMouseMove?: (event: SyntheticMouseEvent<HTMLElement>) => mixed,

  /** True if this result is active. Defaults to false */
  active?: boolean,

  /** result position in result list */
  resultIndex?: number,
|};

/**
 * A results which allows the user to go 'nearby'. Selecting a result of this type will return a TypeaheadResult of
 * { type: "nearby" }
 *
 * Note that the consumer of the <Typeahead/> is expected to handle the result of type 'nearby' and perform the actual
 * geolocation logic. This component is purely for display purposes.
 *
 * Note that this is intended to be used inside a <NavigableList/>
 */
const GoNearbyResult = (props: Props) => {
  const onSelection = (event: SyntheticEvent<HTMLElement> | KeyboardEvent) => {
    const userInteractionType: UserInteractionType = event.type === 'click' ? 'click' : 'enter';
    const { tracker, resultIndex } = props;

    // ETL Trackers
    const trackingData = {
      resultIndex,
      type: 'NEARBY',
      value: 1,
    };

    tracker.trackSelection(trackingData, userInteractionType);
    tracker.trackEventViaMEVTCookie(trackingData, userInteractionType);

    if (props.onSelection) {
      props.onSelection(event, {
        type: 'nearby',
      });
    }
  };
  return (
    <NavigableListItem
      onSelection={onSelection}
      onMouseMove={props.onMouseMove}
      active={props.active}
    >
      <BasicResult title={localize('mx_nearby')} iconName="nearby-fill" active={props.active} />
    </NavigableListItem>
  );
};

GoNearbyResult.defaultProps = {
  onSelection: undefined,
  onMouseMove: undefined,
  active: false,
  resultIndex: undefined,
};

export default GoNearbyResult;
